<template>
  <div>
    <b-button-group size="sm" :class="{ 'd-inline': true, 'd-md-none': !alwaysVertical }" vertical>
      <b-button
        v-for="(btn, idx) in fTypeButtons"
        :key="idx"
        :pressed.sync="btn.selected"
        :disabled="disabled"
        :variant="buttonVariant"
      >
        {{ btn.caption }}
        <b-badge variant="success" v-if="btn.selected">Angezeigt</b-badge>
        <b-badge variant="warning" v-if="!btn.selected">Ausgeblendet</b-badge>
      </b-button><!-- Prevent whitespace and therefore spacing between elements
      --><b-button :pressed.sync="showOtherFTypes"
                :variant="buttonVariant"
                :disabled="disabled">
        Andere
        <b-badge variant="success" v-if="showOtherFTypes">Angezeigt</b-badge>
        <b-badge variant="warning" v-if="!showOtherFTypes">Ausgeblendet</b-badge>
      </b-button>
    </b-button-group>
    <b-button-group size="sm" class="d-none d-md-inline" v-if="!alwaysVertical">
      <b-button
        v-for="(btn, idx) in fTypeButtons"
        :key="idx"
        :pressed.sync="btn.selected"
        :disabled="disabled"
        :variant="buttonVariant"
      >
        {{ btn.caption }}
        <b-badge variant="success" v-if="btn.selected">Angezeigt</b-badge>
        <b-badge variant="warning" v-if="!btn.selected">Ausgeblendet</b-badge>
      </b-button><!-- Prevent whitespace and therefore spacing between elements
      --><b-button :pressed.sync="showOtherFTypes"
                :variant="buttonVariant"
                :disabled="disabled">
        Andere
        <b-badge variant="success" v-if="showOtherFTypes">Angezeigt</b-badge>
        <b-badge variant="warning" v-if="!showOtherFTypes">Ausgeblendet</b-badge>
      </b-button>
    </b-button-group>
  </div>
</template>

<script>
  import { FILE_TYPE_MAP } from '../constants'

  export default {
    name: 'ResourceTypeFilter',
    props: {
      disabled: {
        type: Boolean,
        default: () => { return false }
      },
      enableDefaultAll: {
        type: Boolean,
        default: () => { return false }
      },
      enableDefault: {
        type: String,
        default: () => { return 'text' }
      },
      alwaysVertical: {
        type: Boolean,
        default: () => { return false }
      }
    },
    data: function () {
      const fileButtons = []
      for (const fType in FILE_TYPE_MAP) {
        let selected
        if (fType === this.enableDefault) {
          selected = true
        } else {
          selected = this.enableDefaultAll
        }
        fileButtons.push({
          caption: FILE_TYPE_MAP[fType]['name'],
          fType: fType,
          selected: selected
        })
      }

      return {
        fTypeButtons: fileButtons,
        showOtherFTypes: this.enableDefaultAll
      }
    },
    methods: {
      filterSelectedObjects (obj) {
        for (const fType in this.fTypeButtons) {
          if (obj['fileType'] === this.fTypeButtons[fType]['fType']) {
            if (this.fTypeButtons[fType]['selected']) {
              return true
            } else {
              return false
            }
          }
        }
        return this.showOtherFTypes
      }
    },
    computed: {
      buttonVariant: function () {
        if (this.disabled) {
          return 'outline-secondary'
        }
        return 'outline-primary'
      }
    }
  }
</script>


<style lang="scss" scoped>
  @import '../style/bootstrap-component-include';
</style>



// WEBPACK FOOTER //
// src/components/ResourceTypeFilter.vue